<template>
  <div v-if="chatDataCenter.isJSON(message.messageContent) && JSON.parse(message.messageContent).showResolveStatusLabel">
    <div class="smartlp-msg-news-solve" style="border: none;" v-if="chatDataCenter.linkInfo.solveFlag==1&&$messageType.R==message.messageType&&message.bindId!=null&&(message.solveStatus!=null)">
<!--      <p-->
<!--        style="text-align: center; color: #7F7F7F"-->
<!--        v-if="message.solveStatus == '1'"-->
<!--      >-->
<!--        以上答案是否对您有帮助？-->
<!--      </p>-->
      <div class="smartlp-msg-news-solve-state" v-if="message.solveStatus=='1'" @click="evaluateRobotAnswer('2',messageIndex,message)">
        <img src="../../../static/images/solve-ok-new.png" class="solveImg"><span style="color:#058DFF">有帮助</span>
      </div>
      <div class="smartlp-msg-news-solve-state" v-if="message.solveStatus=='1'" @click="evaluateRobotAnswer('3',messageIndex,message)" style="border: none;">
        <img src="../../../static/images/solve-no-new.png" class="solveImg" ><span style="color:#F599A0">无帮助</span>
      </div>
      <div class="smartlp-msg-news-solved" v-if="message.solveStatus=='2'&&message.solveStatus!='1'">
        <img src="../../../static/images/solve-ok-new.png" class="solveImg"><span  style="color:#058DFF">有帮助</span>
      </div>
      <!--<div class="smartlp-msg-news-solve-state" v-if="message.solveStatus=='2'&&message.solveStatus!='1'">-->
      <!--<img src="../../../static/images/solve-no.png"><span style="color:#4d546c">未解决</span>-->
      <!--</div>-->
      <!--<div class="smartlp-msg-news-solve-state" v-if="message.solveStatus=='3'&&message.solveStatus!='1'">-->
      <!--<img src="../../../static/images/solve-ok.png" ><span style="color:#4d546c">已解决</span>-->
      <!--</div>-->
      <div class="smartlp-msg-news-solved" v-if="message.solveStatus=='3'&&message.solveStatus!='1'">
        <img src="../../../static/images/solve-no-new.png" class="solveImg" ><span style="color:#F599A0">无帮助</span>
      </div>
    </div>
  </div>

</template>

<script>
  import chatDataCenter from "../../jsSdk/chatDataCenter";
  export default {
    name: "solve-show",
    props: ["message","messageIndex"],
    data() {
      return {
        chatDataCenter,
      }
    },
    methods:{
      /**
       * 机器人回答
       */
      evaluateRobotAnswer:function (solveStatus,index,item) {
        var channel='web';
        if (this.$config.sourceTerminal=='WEB'){
          channel='web';
        }
        chatDataCenter.apiEvaluateRobotAnswer(solveStatus,channel,index,item)
      },
    },
  }
</script>

<style scoped>
  @import "../../../static/css/main.css";
  .solveImg{
    width: 16px;
  }
</style>
